import { render, staticRenderFns } from "./admin-layout.component.vue?vue&type=template&id=5679ba18"
import script from "./admin-layout.component.ts?vue&type=script&lang=ts&external"
export * from "./admin-layout.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5679ba18')) {
      api.createRecord('5679ba18', component.options)
    } else {
      api.reload('5679ba18', component.options)
    }
    module.hot.accept("./admin-layout.component.vue?vue&type=template&id=5679ba18", function () {
      api.rerender('5679ba18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/admin-layout/admin-layout.component.vue"
export default component.exports